import { exponential } from './backoff.js';
import { Machina } from './machina.js';
/**
 * Keep the WebSocket connected. When closed, a new socket is created.
 *
 * By default, it uses exponential backoff with a 1 second delay.
 * You can change this behavior by passing in a `backoff` function and `delay` value.
 *
 * @example
 * ```ts
 * const socket = new WebSocket('wss://example.com');
 *
 * for await (const socket of reanimate(socket)) {
 *   // socket is reanimated
 *   handleSocket(socket);
 * }
 * ```
 */
function reanimate(socket, opts = {}) {
    const machina = new Machina();
    const { backoff = exponential, delay = 1000 } = opts;
    /** Set up the WebSocket for reanimation. */
    function rigSocket(socket, attempt = 0) {
        socket.addEventListener('close', handleClose, { once: true });
        /** Whether the socket has been closed manually. */
        let closed = false;
        // Track when a WebSocket is manually closed, and stop the generator.
        const close = socket.close.bind(socket);
        socket.close = function (...args) {
            closed = true;
            close(...args);
            machina.close();
        };
        function handleClose() {
            if (!closed) {
                setTimeout(() => {
                    socket = new WebSocket(socket.url);
                    rigSocket(socket, attempt + 1);
                    machina.push(socket);
                }, backoff(attempt, delay));
            }
        }
    }
    rigSocket(socket);
    return machina.stream();
}
export { reanimate };
